import axios, { AxiosError, AxiosResponse } from "axios";
import { getAuthUser } from "src/services/Authentication/AuthenticationService";
import { removeAuthUser } from "../services/Authentication/AuthenticationService";
import store from "../store/index";
import { login, logout } from "src/store/Authentication/authActions";
import { IApiResponse } from "../shared/models/IApiResponse";
import { alertFromAPIResponse } from "src/shared/services/AlertService";
import { AuthAPIService } from "./Authentication/API_AuthService";
import { removeStoreXUser } from "src/services/Stores/FilteredStoreService";

const axiosApiInstanceFileJSON = axios.create();
axiosApiInstanceFileJSON.defaults.baseURL = process.env.REACT_APP_RETAIL_API_URL;

const axiosDefaultHeaders = (token: string) => {
  return {
    Authorization: `Bearer ${token}`,
    // Accept: "application/json",
    "Content-Type": "application/json",
  };
};

// Append Token
axiosApiInstanceFileJSON.interceptors.request.use(
  async config => {
    const token = getAuthUser().user?.jwtToken || "";
    config.headers = axiosDefaultHeaders(token);
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

axiosApiInstanceFileJSON.interceptors.response.use(
  (response): any => {
    const responseData = response.data as IApiResponse;
    alertFromAPIResponse(responseData);
    return response;
  },
  async function (err) {
    const error = err as AxiosError;
    const originalRequest = error.config;

    if (error.response?.status !== 401) {
      const { data } = (error.response as AxiosResponse<IApiResponse>) || {};
      
      if (data) {
        alertFromAPIResponse(data)
      }
      if (error.response?.status == 403) {
        alertFromAPIResponse({
          success: false,
          message: 'No tiene permiso para realizar esta operación.',
          data: {},
          errors: [],
          total: 0
        } as IApiResponse)
      }

      if (error.response?.status == 401) {
        alertFromAPIResponse({
          success: false,
          message: 'Su sesión ha finalizado',
          data: {},
          errors: [],
          total: 0
        } as IApiResponse)
      }

      return Promise.reject(error)
    }

    const refreshToken = getAuthUser().user?.refreshToken || "";

    return await AuthAPIService.refreshToken(refreshToken)
      .then(auth => {
        store.dispatch(login(auth));
        axiosApiInstanceFileJSON.defaults.headers = axiosDefaultHeaders(
          auth.jwtToken
        );
        originalRequest.headers = axiosDefaultHeaders(auth.jwtToken);

        return Promise.resolve(axiosApiInstanceFileJSON(originalRequest));
      })
      .catch(error => {
        removeAuthUser();
        removeStoreXUser();
        store.dispatch(logout());
        return Promise.reject(error);
      });
  }
);

export default axiosApiInstanceFileJSON;
